import Sortable from 'sortablejs';

export default {
  properties: {
    groupSortable: {
      type: Boolean,
      default: false,
    },

    rowSortable: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    if (this.groupSortable) this.initGroupSortable();
    if (this.rowSortable) {
      this.initRowSortable();

      this.verticalScrollHolder = this.querySelector('.grid-vertical-scroll-holder');
      this.listenTo(this, {
        'tao:sortableOnChoose': (e) => {
          const { height } = e.detail.item.getBoundingClientRect();
          this.verticalScrollHolder.style.height = `${height}px`;
        },
        'tao:sortableOnUnchoose': () => {
          this.verticalScrollHolder.style.height = null;
        },
      });
    }
  },

  initGroupSortable() {
    this.groupSortableInstance = Sortable.create(this.querySelector('.grid-content'), {
      sort: true,
      draggable: '.grid-group[sortable]',
      handle: '.group-header .drag-handle, .group-header .title-container',
      animation: false,
      fallbackOnBody: true,
      invertSwap: true,
      forceFallback: (window.gon && window.gon.sortableFallback) || false,
      onChoose: (e) => {
        this.headerRow.style.transform = 'translateZ(0)';
        this.namespacedTrigger('sortableOnChoose', { detail: e, bubbles: true });
      },
      onUnchoose: (e) => {
        this.headerRow.style.transform = null;
        this.namespacedTrigger('sortableOnUnchoose', { detail: e, bubbles: true });
      },
      onStart: ({ item }) => this.startGroupSorting({ currentGroup: item }),
      onEnd: ({ item, oldDraggableIndex, newDraggableIndex }) => {
        this.endGroupSorting({
          currentGroup: item,
          oldIndex: oldDraggableIndex,
          newIndex: newDraggableIndex,
        });

        if (oldDraggableIndex !== newDraggableIndex) {
          this.namespacedTrigger('groupSortableEnd', {
            detail: { item },
            bubbles: true,
          });
        }
      },
    });
  },

  initRowSortable() {
    const sortableElements = [
      ...this.querySelectorAll('.grid-group .group-content'),
    ];

    this.rowSortableInstances = sortableElements
      .map(sortableEl => Sortable.create(sortableEl, {
        group: 'tr-grid-todo-row',
        sort: true,
        draggable: 'tr-grid-todo-row[sortable]:not([editing])',
        handle: '.grid-sticky-cell',
        delay: 50,
        fallbackOnBody: true,
        animation: false,
        invertSwap: true,
        forceFallback: (window.gon && window.gon.sortableFallback) || false,
        onChoose: (e) => {
          this.namespacedTrigger('sortableOnChoose', { detail: e, bubbles: true });
        },
        onUnchoose: (e) => {
          this.namespacedTrigger('sortableOnUnchoose', { detail: e, bubbles: true });
        },
        onStart: ({ item }) => {
          this.classList.add('sorting');
          item.classList.add('sortable-sorting');
        },
        onEnd: ({
          to, from, item, oldDraggableIndex, newDraggableIndex,
        }) => {
          // eslint-disable-next-line no-param-reassign
          item.style.transform = null;
          this.classList.remove('sorting');
          item.classList.remove('sortable-sorting');

          const changed = from !== to || oldDraggableIndex !== newDraggableIndex;
          this.namespacedTrigger('rowSortableEnd', {
            detail: { item, changed },
            bubbles: true,
          });
        },
      }));
  },

  startGroupSorting({ currentGroup }) {
    const stickyGroup = this.querySelector('.grid-group[header-sticky]');
    if (stickyGroup) {
      stickyGroup.headerSticky = false;
      this.stickyGroup = stickyGroup;
    }

    const groups = [...this.querySelectorAll('.grid-group')];
    const groupCountAbove = groups.findIndex(group => group === currentGroup);
    const groupCountBlow = groups.length - groupCountAbove;

    const { scrollHeight } = this.verticalContainer;
    const { offsetTop } = currentGroup;
    const { height: groupHeight } = currentGroup.header.getBoundingClientRect();
    const { height: headerHeight } = this.header.getBoundingClientRect();

    this.gridContentStyle = this.querySelector('.grid-content').style;
    this.gridContentStyle.paddingTop = `${
      offsetTop - headerHeight - groupCountAbove * groupHeight
    }px`;
    this.gridContentStyle.paddingBottom = `${
      scrollHeight - offsetTop - groupCountBlow * groupHeight
    }px`;

    this.classList.add('sorting', 'sorting-group');
  },

  endGroupSorting({ currentGroup, oldIndex, newIndex }) {
    this.headerRow.style.transform = null;

    // eslint-disable-next-line no-param-reassign
    currentGroup.style.transform = null;
    this.classList.remove('sorting', 'sorting-group');

    if (this.gridContentStyle) {
      this.gridContentStyle.paddingTop = '';
      this.gridContentStyle.paddingBottom = '';
      this.gridContentStyle = null;
    }

    if (newIndex !== oldIndex) {
      const { top: groupTop } = currentGroup.getBoundingClientRect();
      const {
        top: viewportTop, bottom: viewportBottom,
      } = this.verticalContainer.getBoundingClientRect();

      if (groupTop < viewportTop || groupTop > viewportBottom) {
        this.verticalContainer.scrollTop = currentGroup.offsetTop;
      }

      this.stickyGroup = null;
    } else if (this.stickyGroup) {
      this.stickyGroup.headerSticky = true;
      this.stickyGroup = null;
    }
  },

  destroyRowSortable() {
    if (this.rowSortableInstances) {
      this.rowSortableInstances
        .splice(0).forEach(sortable => sortable.destroy());
    }
  },

  recreateRowSortable() {
    this.destroyRowSortable();
    this.initRowSortable();
  },

  disconnected() {
    if (this.groupSortableInstance) {
      this.groupSortableInstance.destroy();
      this.groupSortableInstance = null;
    }

    this.destroyRowSortable();
  },
};
